<div *ngIf="((superAdmin || superUser || subAdmin))" class="d-flex flex-column align-items-center text-center pb-2">
    <h1 class="fw-bold border-bottom p-2 mx-auto">
        <span *ngIf="((superAdmin || superUser || subAdmin))">
            {{'TIPS.MANAGEMENT_FARMER' | translate }}
        </span>
        <span *ngIf="!((superAdmin || superUser || subAdmin))">
            {{'TIPS.MANAGEMENT' | translate }}
        </span>
    </h1>
    <span class="usersInfo">
        <strong>
            {{'TIPS.CONSULTANT' | translate }}
        </strong>: {{consultantInfo.name}}
    </span>
    <div id="cardsContainer" *ngIf="((superAdmin || superUser || subAdmin))">
        <mat-card class="actionCard" (click)="farmerUsageAll()">
            <div class="cardHeader">
                <i class="icon fa-solid fa-chart-pie" [ngClass]="getIconClass('pie-icon')"></i>
            </div>
            <mat-card-title id="titleCards"> {{'TIPS.CARD_FORUM_TITLE' | translate }}
                <p class="farmerName">
                    {{consultantInfo.name}}
                </p>
            </mat-card-title>
            <mat-card-content id="descCards">
                {{'TIPS.CARD_FORUM_DESCRIPTION' | translate }}
            </mat-card-content>
        </mat-card>
    
        <mat-card class="actionCard" [routerLink]="['/tips/consultant-info']">
            <div class="cardHeader">
                <i class="icon fa-solid fa-users" [ngClass]="getIconClass('user-icon')"></i>
            </div>
            <mat-card-title id="titleCards"> {{'TIPS.CARD_INFO_CONSULTANTS_TITLE' | translate }}</mat-card-title>
            <mat-card-content id="descCards">
                {{'TIPS.CARD_INFO_CONSULTANTS_DESCRIPTION' | translate }}
            </mat-card-content>
        </mat-card>

          <mat-card class="actionCard" [routerLink]="['/tips/fly-stats']">
            <div class="cardHeader">
                <i class="icon fa-solid fa-chart-line" [ngClass]="getIconClass('stats-icon')"></i>
            </div>
            <mat-card-title id="titleCards"> {{'TIPS.FLY_STATISTICS_TITLE' | translate }}</mat-card-title>
            <mat-card-content id="descCards">
                {{'TIPS.FLY_STATISTICS_DESC' | translate }}
            </mat-card-content>
        </mat-card>
    </div>
    <div id="cardsContainer" *ngIf="!((superAdmin || superUser || subAdmin))">
        <mat-card class="actionCard" [routerLink]="['/tips/questions']">
            <div class="cardHeader">
                <i class="icon fa-solid fa-chart-pie" [ngClass]="getIconClass('user-icon')"></i>
            </div>
            <mat-card-title id="titleCards">{{'TIPS.CARD_FORUM_TITLE' | translate }}</mat-card-title>
            <mat-card-content id="descCards">
                {{'TIPS.CARD_FORUM_DESCRIPTION' | translate }}
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div class="d-flex flex-column align-items-center text-center py-2">
    <h1 class="fw-bold border-bottom p-2 mx-auto">
        <span *ngIf="((superAdmin || superUser || subAdmin))">
            {{'TIPS.MANAGEMENT' | translate }}
        </span>
        <span *ngIf="!((superAdmin || superUser || subAdmin))">
            {{'TIPS.MANAGEMENT_FARMER' | translate }}
        </span>
    </h1>
    <p class="usersInfo">
        <strong>
            {{'TIPS.FARMER' | translate }}
        </strong>
        :
        {{farmerInfo.first_name}} {{farmerInfo.last_name}}
    </p>
</div>
<div id="cardsContainer">
    <mat-card class="actionCard" [routerLink]="['/upload']">
        <div class="cardHeader">
            <i class="icon fa-solid fa-cloud-arrow-up" [ngClass]="getIconClass('upload-icon')"></i>
        </div>
        <mat-card-title id="titleCards"> {{'TIPS.CARD_FILE_UPLOAD_TITLE' | translate }}</mat-card-title>
        <mat-card-content id="descCards">
            {{'TIPS.CARD_FILE_UPLOAD_DESCRIPTION' | translate }}
        </mat-card-content>
    </mat-card>
    <mat-card *ngIf="((superAdmin || superUser || subAdmin))" class="actionCard" (click)="farmerUsage()">
        <div class="cardHeader">
            <i class="icon fa-solid fa-chart-pie" [ngClass]="getIconClass('pie-icon')"></i>
        </div>
        <mat-card-title id="titleCards">
            {{'TIPS.CARD_FORUM_TITLE_FARMER' | translate }}
            <p class="farmerName">
                {{farmerInfo.first_name}} {{farmerInfo.last_name}}
            </p>
        </mat-card-title>
        <mat-card-content id="descCards">
            {{'TIPS.CARD_FORUM_DESCRIPTION' | translate }}
        </mat-card-content>
    </mat-card>
    <mat-card *ngIf="!((superAdmin || superUser || subAdmin))" class="actionCard" (click)="farmerUsageAll()">
        <div class="cardHeader">
            <i class="icon fa-solid fa-chart-pie" [ngClass]="getIconClass('pie-icon')"></i>
        </div>
        <mat-card-title id="titleCards">
            {{'TIPS.CARD_FORUM_TITLE_FARMER' | translate }}
            <p class="farmerName">
                {{farmerInfo.first_name}} {{farmerInfo.last_name}}
            </p>
        </mat-card-title>
        <mat-card-content id="descCards">
            {{'TIPS.CARD_FORUM_DESCRIPTION' | translate }}
        </mat-card-content>
    </mat-card>
    <mat-card class="actionCard" [routerLink]="['/pests']">
        <div class="cardHeader">
            <i class="icon fa-solid fa-bug" [ngClass]="getIconClass('bug-icon')"></i>
        </div>
        <mat-card-title id="titleCards">
            {{'TIPS.CARD_OPTIMIZATIONS_TITLE' | translate }}
        </mat-card-title>
        <mat-card-content id="descCards">
            {{'TIPS.CARD_OPTIMIZATIONS_DESCRIPTION' | translate }}
        </mat-card-content>
    </mat-card>
    <mat-card class="actionCard" [routerLink]="['/weather-stations']">
        <div class="cardHeader">
            <i class="icon fa-solid fa-cloud-bolt" [ngClass]="getIconClass('weather-icon')"></i>
        </div>
        <mat-card-title id="titleCards"> {{'TIPS.CARD_WEATHER_TITLE'| translate }}</mat-card-title>
        <mat-card-content id="descCards">
            {{'TIPS.CARD_WEATHER_DESCRIPTION' | translate }}
        </mat-card-content>
    </mat-card>
    <mat-card class="actionCard" [routerLink]="['/contact-us']">
        <div class="cardHeader">
            <i class="icon fa-solid fa-address-book" [ngClass]="getIconClass('contact-icon')"></i>
        </div>
        <mat-card-title id="titleCards"> {{'TIPS.CARD_CONTACT_TITLE' | translate }}</mat-card-title>
        <mat-card-content id="descCards">
            {{'TIPS.CARD_CONTACT_DESCRIPTION' | translate }}
        </mat-card-content>
    </mat-card>
    <mat-card class="actionCard" [routerLink]="['/carbon-footprint']">
        <div class="cardHeader">
            <i class="icon fa-solid fa-leaf" [ngClass]="getIconClass('leaf-icon')"></i>
        </div>
        <mat-card-title id="titleCards">{{'TIPS.CARD_CARBON_TITLE' | translate }}</mat-card-title>
        <mat-card-content id="descCards">
            {{'TIPS.CARD_CARBON_DESCRIPTION' | translate }}
        </mat-card-content>
    </mat-card>
    <mat-card class="actionCard" (click)="openIrrigationPage()">
        <div class="cardHeader">
            <i class="icon fa-solid fa-water" [ngClass]="getIconClass('wind-icon')"></i>
        </div>
        <mat-card-title id="titleCards">  {{'TIPS.CARD_IRRIGATION_TITLE' | translate }}</mat-card-title>
        <mat-card-content id="descCards">
            {{'TIPS.CARD_IRRIGATIONS_DESCRIPTION' | translate }}
        </mat-card-content>
    </mat-card>
    <mat-card class="actionCard" [routerLink]="['/management/traps']">
        <div class="cardHeader">
            <i class="icon fa-solid fa-bug-slash" [ngClass]="getIconClass('metal-icon')"></i>
        </div>
        <mat-card-title id="titleCards">{{'TIPS.CARD_DACUS_TITLE' | translate }}</mat-card-title>
        <mat-card-content id="descCards">
            {{'TIPS.CARD_DACUS_DESCRIPTION' | translate }}
        </mat-card-content>
    </mat-card>
</div>